import React from 'react';
import { createRoot } from 'react-dom/client';
import {
    AsgFwContext,
    AsgDictionaryContext,
    AsgAppContext,
    AsgAppGamesContext
} from './src/contexts';
import { GameImprovementsOverly } from './src/components/GameImprovementsOverly/GameImprovementsOverly';
import { Provider } from 'react-redux';

/**
 * inGame placeholders on page and returns true if they found
 * @return {boolean}
 */
const isNeedToRender = () => {
    if (AsgFW.isMobilePamPlatform()) {
        return AsgFW.isPlayerDECountry() && AsgFW.isLoggedIn();
    } else {
        return ! (AsgApp.isUkCountry() && !AsgFW.isLoggedIn());
    }
};

/**
 * return TRUE if player country == DE
 * @returns {boolean}
 */
const isPlayerDECountry = () => {
    if (AsgFW.isLoggedIn()) {
        const playerDetails = AsgFW.getSessionDetails();
        return playerDetails.CountryCode === 'DE';
    }
};

/**
 * Match search games and result data and prepares data for render
 * @return {Promise<void>}
 * @link https://aspireglobal.atlassian.net/l/c/Y4suc6XT
 */
const resultData = async () => {
    /**
     * do nothing in case no Uk Country and not LoggedIn
     */
    if (!isNeedToRender()) {
        return;
    }

    try {
        let state = Games.getFixedGamesList();
        renderReactGameImprovementsComponent(state);
    } catch (e) {
        console.error('search game render failed', e);
    }
};

const isActiveOnMobile = () => {
    return AsgFW.isMobilePamPlatform() && isPlayerDECountry();
};

const renderReactGameImprovementsComponent = (state) => {
    const elm = document.getElementById('game-improvements');
    const { store } = AsgSharedComponents.state;

    elm && createRoot(elm).render(
        <AsgFwContext.Provider value={AsgFW}>
            <AsgDictionaryContext.Provider value={Dictionary}>
                <AsgAppContext.Provider value={AsgApp}>
                    <AsgAppGamesContext.Provider value={Games}>
                        <Provider store={store}>
                            <GameImprovementsOverly gamesListItem={state} onMobile={isActiveOnMobile()}/>
                        </Provider>
                    </AsgAppGamesContext.Provider>
                </AsgAppContext.Provider>
            </AsgDictionaryContext.Provider>
        </AsgFwContext.Provider>
    );
};

export const render = () => {
    resultData();
};
